import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=685abf8f&"
import script from "./uploadBtn.vue?vue&type=script&lang=js&"
export * from "./uploadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports